import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PauseCircleFilledIcon(props: IconProps) {
    return <Icon {...props} iconKey={"pause_circle_filled"}/>
}
